import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import Icon from './Icon.svelte';

export default function ArrowLeftRight($$anchor, $$props) {
	const iconNode = [
		["path", { "d": "M8 3 4 7l4 4" }],
		["path", { "d": "M4 7h16" }],
		["path", { "d": "m16 21 4-4-4-4" }],
		["path", { "d": "M20 17H4" }]
	];

	let rest = $.rest_props($$props, ['$$slots', '$$events', '$$legacy']);

	Icon($$anchor, $.spread_props(
		{
			get iconNode() {
				return iconNode;
			}
		},
		() => rest
	));
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiQXJyb3dMZWZ0UmlnaHQuc3ZlbHRlIl0sInNvdXJjZXNDb250ZW50IjpbIjxzY3JpcHQgbGFuZz1cInRzXCI+XG4gIGltcG9ydCBJY29uIGZyb20gJy4vSWNvbi5zdmVsdGUnO1xuICBjb25zdCBpY29uTm9kZTogW3N0cmluZywgUmVjb3JkPHN0cmluZywgc3RyaW5nPl1bXSA9IFtbXCJwYXRoXCIsIHsgXCJkXCI6IFwiTTggMyA0IDdsNCA0XCIgfV0sIFtcInBhdGhcIiwgeyBcImRcIjogXCJNNCA3aDE2XCIgfV0sIFtcInBhdGhcIiwgeyBcImRcIjogXCJtMTYgMjEgNC00LTQtNFwiIH1dLCBbXCJwYXRoXCIsIHsgXCJkXCI6IFwiTTIwIDE3SDRcIiB9XV07XG4gIGxldCByZXN0ID0gJHByb3BzKCk7XG48L3NjcmlwdD5cbjxJY29uIHtpY29uTm9kZX0gey4uLnJlc3R9IC8+XG4iXSwibWFwcGluZ3MiOiI7O09BQ1MsSUFBSSxNQUFNLGVBQWU7OzBEQURsQyxDQUFDO09BRU8sUUFBNEM7R0FBSyxNQUFNLElBQUksR0FBRyxFQUFFLGNBQWM7R0FBTSxNQUFNLElBQUksR0FBRyxFQUFFLFNBQVM7R0FBTSxNQUFNLElBQUksR0FBRyxFQUFFLGdCQUFnQjtHQUFNLE1BQU0sSUFBSSxHQUFHLEVBQUUsVUFBVTs7O0tBQ2xMLElBQUk7Ozs7Ozs7O1FBRVcsSUFBSTs7QUFEMUIsQ0FBQyJ9